import React, { ReactElement, useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Input,
  Popconfirm,
  Row,
  Space,
  Table,
  Typography,
} from 'antd'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { ITipoDocumento } from '@app'
import { useFetch, useRouter } from '@customHooks'
import { ContainerTabela } from '@pages/style'
import api from '@services/api'

const { Column } = Table

export default function TiposDocumento(): ReactElement {
  const { navigate } = useRouter()
  const [reload, setReload] = useState(false)
  const [source, setSource] = useState<ITipoDocumento[]>([] as ITipoDocumento[])

  const { apiData: tipoDocumentos, isLoading } = useFetch<ITipoDocumento>({
    url: '/tipodocumento',
    reload,
  })

  const onDelete = async (id: number) => {
    await api.delete(`/tipodocumento/${id}`).finally(() => setReload(!reload))
  }

  useEffect(() => {
    setSource(tipoDocumentos)
  }, [tipoDocumentos])

  return (
    <ContainerTabela>
      <Card style={{ marginBottom: '1.5rem' }}>
        <Row align='middle' justify='space-between'>
          <Col>
            <Typography.Title level={4} style={{ margin: 'auto' }}>
              Tipo de Documento
            </Typography.Title>
          </Col>
          <Col>
            <Button
              icon={<PlusOutlined />}
              size='large'
              type='primary'
              onClick={() => navigate('novo')}
            >
              Novo
            </Button>
          </Col>
        </Row>
      </Card>
      <Table
        loading={isLoading}
        dataSource={source}
        rowKey={(record) => record.ID_TIPODOCUMENTO}
      >
        <Column<ITipoDocumento>
          title='Cód.'
          dataIndex='ID_TIPODOCUMENTO'
          width='10%'
          // sorter={(a, b) => a.ID_ATIVIDADE - b.ID_ATIVIDADE}
        />
        <Column<ITipoDocumento>
          title='Descrição'
          dataIndex='DESCTIPODOCTO'
          // sorter={(a, b) => a.DESCATIVIDADE.localeCompare(b.DESCATIVIDADE)}
        />
        <Column<ITipoDocumento>
          title='Abreviatura'
          dataIndex='ABREVIATURA'
          // sorter={(a, b) => a.DESCATIVIDADE.localeCompare(b.DESCATIVIDADE)}
        />
        <Column<ITipoDocumento>
          width='10%'
          render={(_, record) => (
            <Space>
              <Button
                onClick={() =>
                  navigate(`${record.ID_TIPODOCUMENTO}`, {
                    state: record,
                  })
                }
                type='link'
                icon={<EditOutlined />}
              />
              <Popconfirm
                title='Deseja realmente excluir este registro?'
                onConfirm={() => onDelete(record.ID_TIPODOCUMENTO)}
              >
                <Button type='text' icon={<DeleteOutlined />} />
              </Popconfirm>
            </Space>
          )}
        />
      </Table>
    </ContainerTabela>
  )
}
